import React from "react";

import styles from "./Hero.module.scss";

export const Hero = function ({ scrollTo }) {
  return (
    <section id="form" className={styles.hero}>
      <div className={styles.heroContainer}>
        <h1>Higher Education Teaching Certificate</h1>
        <small>ONLINE SHORT COURSE</small>
        <p>
          <em>Embrace a collaborative, engaging approach to your teaching practice.</em>
        </p>
        <button onClick={scrollTo} id="cta-scroll">
          GET MORE INFORMATION
        </button>
      </div>
    </section>
  );
};
